import type { CustomFormErrors, FormErrors } from 'redux-form';

import type { FileType } from '@acceligentllc/shared/enums/fileType';
import type { ResourceStatus } from '@acceligentllc/shared/enums/resourceStatus';

export interface AttachmentFM {
	id: number;
	size: number;
	fileName: string;
	type: FileType;
	status: ResourceStatus;
	storageName: string;
	storageContainer: string;
	/** original version with presigned url */
	originalSrc: string;
	/** ISO_DATETIME */
	lastModifiedAt: string;
}

export default class FileUploadFM {
	attachments: AttachmentFM[];
	uploadedAttachmentIds: number[];
	uploadingAttachments: Record<string, true>;

	static validate = (form: FileUploadFM): FormErrors<FileUploadFM> => {

		const errors: CustomFormErrors<FileUploadFM> = {};

		if (!!form.uploadingAttachments && Object.keys(form.uploadingAttachments).length) {
			errors.uploadingAttachments = 'Attachment upload in progress.';
		}

		return errors as FormErrors<FileUploadFM>;
	};
}

